<template>
  <div class="data-list-container">

    <!-- Prompts -->
    <columns-manager
      :isPromptActive="IsPromptActive.columnsManager"
      :HideableColumns="Columns"
      :isHidden="isHidden"
      @updatePromptColumns="isHidden = $event;"
      @closePromptColumns="IsPromptActive.columnsManager = false;"
    />


    <!-- @cancel="valMultipe.value1='',valMultipe.value2=''"
    @accept="acceptAlert"
    @close="close" -->
    <vs-prompt :active.sync="IsPromptActive.newMovement"
    title="Nuevo movimiento" @accept="addMovement()">
      <div class="newPrompt">

        <h2 class="text-center my-2" :class="'text-'+newMovement.type.color">{{newMovement.type.title}}</h2>

        <label for="" class="vs-select--label">Fecha de pago Estimado</label>
        <vs-input placeholder="" type="date" v-model="newMovement.datePayment" class="newPrompt-item mt-2"/>
        <vs-input placeholder="Precio" v-model.number="newMovement.price" class="newPrompt-item mt-2"/>
        <vs-select autocomplete class="mx-auto mt-2" label="Cuenta" v-model="newMovement.accountID">
          <vs-select-item :key="index" :value="acc.id" :text="acc.name" v-for="(acc,index) in Accounts"/>
        </vs-select>
        <vs-select  autocomplete class="mx-auto mt-2" label="Categoria" v-model="newMovement.categoryID">
          <vs-select-item :key="index" :value="cat.id" :text="cat.name" v-for="(cat,index) in MovementCategory"/>
        </vs-select>
        <vs-input placeholder="Descripción" v-model="newMovement.description" size="large" class="newPrompt-item mt-2"/>
        <vs-row>
          <label class="mr-3">Está pago</label>
          <vs-switch v-model="newMovement.isPayed"/>
        </vs-row>

      </div>
    </vs-prompt>
    <vs-prompt :active.sync="IsPromptActive.newMovementTransfer"
    title="Nuevo movimiento" @accept="addTransfer()">
      <div class="newPrompt">

        <h2 class="text-center my-2" :class="'text-'+newMovement.type.color">{{newMovement.type.title}}</h2>

        <label for="" class="vs-select--label">Fecha de pago</label>
        <vs-input placeholder="" type="date" v-model="newMovement.datePayment" class="newPrompt-item mt-2"/>
        <vs-input placeholder="Precio" v-model.number="newMovement.price" class="newPrompt-item mt-2"/>
        <vs-select autocomplete class="mx-auto mt-2" label="Cuenta" v-model="newMovement.accountID">
          <vs-select-item :key="index" :value="acc.id" :text="acc.name" v-for="(acc,index) in Accounts"/>
        </vs-select>
        <vs-select v-if="newMovement.type.type == 'transferencia'" autocomplete class="mx-auto mt-2" label="Cuenta a transferir" v-model="newMovement.receivingAccountID">
          <vs-select-item :key="index" :value="acc.id" :text="acc.name" v-for="(acc,index) in Accounts"/>
        </vs-select>
        <vs-input placeholder="Descripción" v-model="newMovement.description" size="large" class="newPrompt-item mt-2"/>

      </div>
    </vs-prompt>

    <vs-prompt :active.sync="IsPromptActive.newAccount"
    title="Nuevo movimiento" @accept="addAccount()">

      <div class="newPrompt">
        <vs-input placeholder="Nombre" v-model="newAccount.name" class="newPrompt-item"/>
        <vs-input placeholder="Valor" v-model="newAccount.value" type="number" class="newPrompt-item"/>
        <p class="d-block" style="color: red">Necesito un getBranches</p>
        <vs-input placeholder="Sucursal" v-model="newAccount.branchID" type="number" class="newPrompt-item"/>
        <vs-input placeholder="Relevancia" v-model="newAccount.relevance" type="number" class="newPrompt-item"/>
        <vs-input placeholder="Color" v-model="newAccount.color" type="color" class="newPrompt-item"/>
        <p style="color: orange; font-size: smaller;">Seleccionar colores claros o dejarlo por default en blanco</p>
      </div>

    </vs-prompt>

    <vs-prompt :active.sync="IsPromptActive.editAccount"
    title="Editar cuenta" @accept="saveAccount()">
      <div class="newPrompt">

        <vs-input placeholder="Nombre" v-model="currentAccount.name" class="newPrompt-item"/>
        <vs-input placeholder="Sucursal" v-model="currentAccount.branchID" type="number" class="newPrompt-item"/>
        <vs-input placeholder="Relevancia" v-model="currentAccount.relevance" type="number" class="newPrompt-item"/>
        <vs-input placeholder="Color" v-model="currentAccount.color" type="color" class="newPrompt-item"/>
        <p style="color: orange; font-size: smaller;">Seleccionar colores claros o dejarlo por default en blanco</p>

      </div>
    </vs-prompt>



    <!-- Resumen Cuentas -->
    <div class="my-5">
      <vs-button class="my-5 mx-5" @click="IsPromptActive.newAccount = true" type="border" color="warning">
        <font-awesome-icon icon="plus"/> Cuenta
      </vs-button>
      <vs-row>
        <vs-col v-for="(account,index) in Accounts" :key="index" vs-w="2" vs-sm="6">

          <vs-card class="kaka" :style="'background: '+ account.color">
            <div slot="header">
              <h3 class="text-center">
                {{account.name}}
              </h3>
            </div>
            <div class="text-center">
              <span >${{ showPrice(account.value)}}</span>
            </div>

            <div class="text-center">
              <vs-button type="" @click="editAccount(index)">
                <font-awesome-icon icon="edit" color="black" />
              </vs-button>
            </div>


        </vs-card>


        </vs-col>
      </vs-row>
    </div>


    <!-- Table -->
    <template>
      <vs-table ref="table" :data="Movements" pagination :max-items="itemsPerPage" :noDataText="defaultNoDataText" search>
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" style="padding-bottom: 14px;">
          <div class="flex flex-wrap-reverse items-center">
            <vs-button color="primary" type="filled" class="columnsManagerBtn" @click="manageColumns()">
              <font-awesome-icon icon="columns"/>
            </vs-button>
            <div>
              <vs-button @click="toggleNewMovement('gasto')" type="border" color="danger" class="mr-2">
                <font-awesome-icon icon="plus"/> Gasto
              </vs-button>
              <vs-button @click="toggleNewMovement('ingreso')" type="border" color="success" class="mr-2">
                <font-awesome-icon icon="plus"/> Ingreso
              </vs-button>
              <vs-button @click="toggleTransfer()" type="border" class="mr-2">
                <font-awesome-icon icon="plus"/> Movimiento entre cuentas
              </vs-button>
            </div>
          </div>

          <items-per-page :itemsLength="Movements.length" :currentPage ="currentPage" :itemsPerPage ="itemsPerPage"/>
        </div> <!-- header -->



        <!-- SALE TITLES -->
        <template slot="thead">
          <vs-th v-for="(Col,index) in Columns" v-if="!isHidden[Col.name]" :class="Col.nowrap == false ? '' : 'nowrap'" :key="index">
            {{ Col.title }}
          </vs-th>
        </template>

        <!-- SALE ITEMS -->
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in sortMovements" class="text-center">
            <!-- id -->
            <vs-td v-if="!isHidden.id">
              <vs-chip color="primary">{{ tr.id }}</vs-chip>
            </vs-td>

            <!-- price -->
            <vs-td v-if="!isHidden.price">
              <vs-chip :color="(tr.price >= 0)? 'success':'danger'"> ${{ showPrice(tr.price) }} </vs-chip>
            </vs-td>

            <!-- category -->
            <vs-td v-if="!isHidden.category">
              <vs-chip color="primary">{{ tr.category }}</vs-chip>
            </vs-td>

            <!-- account -->
            <vs-td v-if="!isHidden.description">
                {{ tr.account}}
            </vs-td>

            <!-- isPayed -->
            <vs-td v-if="!isHidden.state">
                <vs-chip :color="tr.isPayed? 'success' : 'warning'">{{ tr.isPayed? 'Si' : 'No' }}</vs-chip>
            </vs-td>

            <!-- date -->
            <vs-td v-if="!isHidden.date">
              {{ tr.datePayment}}
            </vs-td>

            <!-- dateReal -->
            <vs-td v-if="!isHidden.date">
              {{  tr.datePaymentReal ? tr.datePaymentReal : "No pagado"}}
            </vs-td>

            <!-- dateCreated -->
            <vs-td v-if="!isHidden.date">
              {{ tr.dateCreated }}
            </vs-td>

            <!-- descripcion -->
            <vs-td v-if="!isHidden.description">
              {{ tr.description	 }}
            </vs-td>

            <!-- paymentType -->
            <vs-td v-if="!isHidden.paymentType" :data="tr.paymentType" class="nowrap">
              <vs-chip color="primary">{{tr.paymentType}}</vs-chip>
              <!-- <font-awesome-icon :icon="getPaymentIcon(tr.paymentType)" :class="`payment${tr.paymentTypeID}`" class="centeredInTable"/> -->
              <!-- {{ tr.paymentType }} -->
            </vs-td>

            <!-- currency -->
            <vs-td v-if="!isHidden.date">
              <vs-chip color="primary">{{ tr.currency}}</vs-chip>
            </vs-td>

            <!-- Employee -->
            <vs-td v-if="!isHidden.employee">
              <vs-chip color="warning">{{ dataDB.employees.filter((e)=>{return e.id == tr.employeeID})[0].name }}</vs-chip>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </template> <!-- Sale table -->
  </div>
</template>











<script>
// mixins
import { vsTableConfig } from '@/mixins/vsTableConfig.js';

export default {
  mixins: [vsTableConfig],
  props: {
  },


      // Cuanto en tarjeta y cuánto en efectivo
      // Mostrar saldo caja
      // Mostrar saldo banco
      // Pagado con banco, pagado con efectivo, o no pagado
      // Si no pagado, poner cuando hay que pagar
      // Compras a proveedores
      // No solo compras a proveedores. Cualquier salida de plata.
      // Y lo mismo que en la parte de ventas,
      // me tendría que dejar cargar manualmente cualquier otro
      // ingreso de dinero que no sea x ventas.


  data: ()=>({
    movementsTypes: {
      'gasto': {
        type: 'gasto',
        title: 'Gasto',
        color: 'danger'
      },
      'ingreso': {
        type: 'ingreso',
        title: 'Ingreso',
        color: 'success',
      },
      'transferencia': {
        type: 'transferencia',
        title: 'Transferencia entre cuentas',
        color: 'warning'
      }
    },
    newMovement: {
      price: '',
      categoryID: '',
      accountID: '',
      supplierID: 0,
      employeeID: 0,
      isPayed: 1,
      datePayment: null,
      datePaymentReal: null,
      description: '',
      paymentTypeID: 0,
      currencyID: 1,
      receivingAccountID: 0,
      type: {}
    },
    newAccount: {
      name: '',
      value: '',
      color: 'white',
      currencyID: 1,
      typeID: 1,
      branchID: 0,
      relevance: 1,
    },
    currentAccount: {
      name: '',
      value: '',
      color: 'white',
      currencyID: 1,
      typeID: 1,
      branchID: 0,
      relevance: 1,
    },
    IsPromptActive: { columnsManager: false, newMovement: false, newAccount: false, editAccount: false, newMovementTransfer: false},
    // static
    itemsPerPage: 50,
    Columns: [
      { name: 'id', title: 'ID', },
      { name: 'price', title: 'Precio', },
      { name: 'category', title: 'Categoria', },
      { name: 'account', title: 'Cuenta de transferencia', },
      { name: 'isPayed', title: 'Pagado', },
      { name: 'datePayment', title: 'Fecha de pago (estimado)' },
      { name: 'datePaymentReal', title: 'Fecha de pago' },
      { name: 'dateCreated', title: 'Fecha de creacion' },
      { name: 'description', title: 'Descripción' },
      { name: 'paymentType', title: 'Tipo de pago' },
      { name: 'currency', title: 'Moneda' },
      { name: 'employee', title: 'Empleado' },
      
    ],
    // selectedProfile: 0, // Lisandro
    Accounts: [],
    Movements: [],
    MovementCategory: [],
    newMovementErrors: {
      price: false
    }
  }), // DATA
  watch: {

  }, // WATCH

  computed: {
    sortMovements() {
      return this.Movements.concat().sort((a,b)=>(a.dateCreated.localeCompare(b.dateCreated))).reverse()
    },
    User() { //Copiado de TheNavbar.vue
        let index = this.dataDB.employees.findIndex(i => i.id == localStorage.userID);
        if (index == -1) return {};
        return this.dataDB.employees[index];
      },
  }, // COMPUTED
  methods: {
    // loadMovements
    loadMovements() {
      let Params = { isActive: 1 };
      const vm = this;
      this.conectToDB({
        file: 'Accounting', action: 'getMovement', params: Params, //Hacer funcion
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.Movements = res.data.data;
          //console.log(res.data.data)
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    loadAccounts() {
      let Params = { isActive: 1 };
      const vm = this;
      this.conectToDB({
        file: 'Accounting', action: 'getAccount', params: Params, //Hacer funcion
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.Accounts = res.data.data;
          //console.log(res.data.data)
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    loadMovementCategory() {
      let Params = { isActive: 1 };
      const vm = this;
      this.conectToDB({
        file: 'Accounting', action: 'getMovementCategory', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.MovementCategory = res.data.data;
          // console.log("cat", res.data.data)
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    addAccount() {
      const vm = this;
      try {
        this.conectToDB({
          file: 'Accounting', action: 'addAccount', params: vm.newAccount,
          success: function(res){
            if (res.data.error) { console.log(res.data.data); return; }
            vm.loadAccounts() // Carga cuentas
            vm.myNotify('success', 'Exito!', "Cuenta agregada");
          }, error: function(error) { vm.myNotify('danger', 'Error', error); },
        });

      }
      catch (error) {
        this.myNotify('danger', 'Error!', 'Ocurrio un error');
        console.log(error)
      }
      finally {
        this.newAccount= {
          name: '',
          value: '',
          color: 'white',
          currencyID: 1,
          typeID: 1,
          branchID: 0,
          relevance: 1,
        }
      }
    },
    toggleNewMovement(movementType){
      this.IsPromptActive.newMovement = true
      this.newMovement.type = this.movementsTypes[movementType]
    },
    addMovement() {
      const vm = this;

      this.movementValidator()
      if (this.newMovementErrors.error) {return}

      //console.log("add Mov")
      if(this.newMovement.type.type == 'gasto') {
        this.newMovement.price>0 ? this.newMovement.price = -this.newMovement.price : null
      }
      if(this.newMovement.type.type == 'ingreso') {
        this.newMovement.price<0 ? this.newMovement.price = -this.newMovement.price : null
      }
      if(this.newMovement.isPayed == true) {
        this.newMovement.datePayment += " " + new Date().toLocaleTimeString()
        this.newMovement.datePaymentReal = this.newMovement.datePayment
      } else {
        this.newMovement.datePayment += " " + new Date().toLocaleTimeString()
        this.newMovement.datePaymentReal += " " + new Date().toLocaleTimeString()
      }

      console.log("NewMov", this.newMovement)
      try {
        this.conectToDB({
          file: 'Accounting', action: 'addMovement', params: vm.newMovement,
          success: function(res){
            if (res.data.error) { console.log(res.data); return; }

            // console.log("dsa", vm.newMovement)
            // console.log("Accs",vm.Accounts,"filt:",vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID}))
            let Account={
              id: vm.newMovement.accountID,
              value: vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID})[0].value+vm.newMovement.price
            }
            // console.log("Acc:", Account)
            vm.conectToDB({
              file: 'Accounting', action: 'modifyAccount', params: Account,
              success: function(res){
                if (res.data.error) { console.log(res.data.data); return; }
                vm.myNotify('success', 'Exito!', "Cuenta de llegada editada");
                vm.loadAccounts()
              }, error: function(error) { vm.myNotify('danger', 'Error', error); },
            })

            vm.myNotify('success', 'Exito!', "Movimiento creado!");
            vm.loadMovements();
            vm.newMovement= {
              price: '',
              categoryID: '',
              accountID: '',
              supplierID: 0,
              employeeID: vm.User.id,
              isPayed: 1,
              datePayment: null,
              datePaymentReal: null,
              description: '',
              paymentTypeID: 0,
              currencyID: 1,
              receivingAccountID: 0,
              type: {}
            }
          }, error: function(error) { vm.myNotify('danger', 'Error', error); },
        });
      }
      catch (error) {
        this.myNotify('danger', 'Error!', 'Ocurrio un error');
        console.log(error)
        this.loadMovements();
        this.newMovement= {
          price: '',
          categoryID: '',
          accountID: '',
          supplierID: 0,
          employeeID: this.User.id,
          isPayed: 1,
          datePayment: null,
          datePaymentReal: null,
          description: '',
          paymentTypeID: 0,
          currencyID: 1,
          receivingAccountID: 0,
          type: {}
        }
      }
    },

    toggleTransfer() {
      this.newMovement.receivingAccountID = null,
      this.IsPromptActive.newMovementTransfer = true
      this.newMovement.type = this.movementsTypes['transferencia']
      this.newMovement.categoryID = 6
      this.newMovement.isPayed = 1
    },
    addTransfer() {
      this.movementValidator()
      if (this.newMovementErrors.error) {return}
      if(this.newMovement.price<=0) {this.myNotify('danger', 'El Precio debe ser mayor a 0');return}


      this.newMovement.datePayment += " " + new Date().toLocaleTimeString()
      this.newMovement.datePaymentReal = this.newMovement.datePayment
      
     
      // console.log("Iniciando Transfer")
      // console.log("NM1", this.newMovement)
      const vm = this;
      try {
        //Transferencia 1
        this.conectToDB({
          file: 'Accounting', action: 'addMovement', params: vm.newMovement,
          success: function(res){
            
            // console.log("Trans1 Exito")
            if (res.data.error) { console.log(res.data.data); return; }

            //Actualizo cuenta
            // console.log("Accs:",vm.Accounts,"filt:", vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID}) )
            let Account={
              id: vm.newMovement.accountID,
              value: vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID})[0].value-vm.newMovement.price
            }
            // console.log("Acc:", Account)
            vm.conectToDB({
              file: 'Accounting', action: 'modifyAccount', params: Account,
              success: function(res){
                if (res.data.error) { console.log(res.data.data); return; }
                vm.myNotify('success', 'Exito!', "Cuenta de salida editada");
              }, error: function(error) { vm.myNotify('danger', 'Error', error); },
            })


            // console.log("NM2",vm.newMovement)
            vm.newMovement.accountID = vm.newMovement.receivingAccountID // Ahora cambio la ID a la otra cuenta
            vm.newMovement.price = -vm.newMovement.price // Cambio el precio contrario
            //Transferencia 2
            vm.conectToDB({
              file: 'Accounting', action: 'addMovement', params: vm.newMovement,
              success: function(res){
                // console.log("Trans2 Exito")
                if (res.data.error) { console.log(res.data.data); return; }
                vm.myNotify('success', 'Exito!', "Transferencia creado!");

                //Actualizo cuenta
                // console.log("filt:",vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID}))
                let Account={
                  id: vm.newMovement.accountID,
                  value: vm.Accounts.filter((e)=>{return e.id==vm.newMovement.accountID})[0].value-vm.newMovement.price
                }
                // console.log("Acc:", Account)
                vm.conectToDB({
                  file: 'Accounting', action: 'modifyAccount', params: Account,
                  success: function(res){
                    if (res.data.error) { console.log(res.data.data); return; }
                    vm.myNotify('success', 'Exito!', "Cuenta de llegada editada");
                    vm.loadAccounts()
                  }, error: function(error) { vm.myNotify('danger', 'Error', error); },
                })

                vm.loadMovements();
                vm.newMovement= {
                  price: '',
                  categoryID: '',
                  accountID: '',
                  supplierID: 0,
                  employeeID: vm.User.id,
                  isPayed: 1,
                  datePayment: null,
                  datePaymentReal: null,
                  description: '',
                  paymentTypeID: 0,
                  currencyID: 1,
                  receivingAccountID: 0,
                  type: {}
                }

              }, error: function(error) { vm.myNotify('danger', 'Error', error); },
            });

          }, error: function(error) { 
            vm.myNotify('danger', 'Error', error);
            vm.newMovement= {
                    price: '',
                    categoryID: '',
                    accountID: '',
                    supplierID: 0,
                    employeeID: vm.User.id,
                    isPayed: 1,
                    datePayment: null,
                    datePaymentReal: null,
                    description: '',
                    paymentTypeID: 0,
                    currencyID: 1,
                    receivingAccountID: 0,
                    type: {}
                  }},
        });
      }
      catch (error) {
        this.myNotify('danger', 'Error!', 'Ocurrio un error');
        console.log(error)
      }
    },
    movementValidator() {
      this.newMovementErrors = {}
      this.newMovement.datePayment == null ? this.newMovementErrors.datePayment = true : null
      this.newMovement.price == 0 ? this.newMovementErrors.price = true : null
      this.newMovement.accountID == this.newMovement.receivingAccountID ? this.newMovementErrors.account = true : null
      this.newMovement.accountID == 0 ? this.newMovementErrors.account = true : null
      this.newMovement.receivingAccountID == null | this.newMovement.receivingAccountID == 0 && this.newMovement.type.type == "transferencia" ? this.newMovementErrors.account = true : null
      
      if (this.newMovementErrors.price | this.newMovementErrors.account | this.newMovementErrors.datePayment) {this.newMovementErrors.error = true} else {this.newMovementErrors.error = false}
      
      if (this.newMovementErrors.error) {
        if (this.newMovementErrors.account) {this.myNotify('danger', 'Error en el campo cuenta');}
        if (this.newMovementErrors.price) {this.myNotify('danger', 'Error en el campo precio');}
        if (this.newMovementErrors.datePayment) {this.myNotify('danger', 'Coloca una fecha de pago');}
      }
      // console.log(this.newMovementErrors, this.newMovement)
    },

    editAccount(index) {
      this.IsPromptActive.editAccount = true
      this.currentAccount = this.Accounts[index]
    },
    saveAccount() {
      // console.log("Account: ", this.currentAccount)
      const vm = this;
      try {
        this.conectToDB({
          file: 'Accounting', action: 'modifyAccount', params: vm.currentAccount,
          success: function(res){
            if (res.data.error) { console.log(res.data.data); return; }
            vm.myNotify('success', 'Exito!', "Cuenta editada");
            vm.loadAccounts()
          }, error: function(error) { vm.myNotify('danger', 'Error', error); },
        });

      }
      catch (error) {
        this.myNotify('danger', 'Error!', 'Ocurrio un error');
        console.log(error)
      }
      finally {
        this.currentAccount = {}
      }
    }
  }, // METHODS
  created() {
    this.loadMovements();
    this.loadAccounts();
    this.loadMovementCategory();
  },
  mounted() {
    this.newMovement.employeeID = this.User.id
  },
}
</script>

<style lang="scss">
  .newPrompt-item {
    margin-bottom: 10px;
    width: 100%;
  }
</style>




<!-- vm.$set(vm.Sales[position], 'Products', res.data.data)


for (let i in vm.Sales) {
  vm.loadSaleProducts(vm.Sales[i].id, i);
} -->
